import _Tooltip from "@material-ui/core/esm/Tooltip";
import React from 'react';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import classes from './before-approving-mockup.scss';
const rules = ['The Pantone colors are correct', 'The color of the item(s) you ordered is correct', 'The artwork is the right size and in the right place', 'The decoration method is correct'];
const tooltipText = "Mockup approval isn't available until mockup hasn't been uploaded.";
const BeforeApprovingMockup = ({
  isMockupAvailable,
  onSkip
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.beforeApprovingWrapper
}, /*#__PURE__*/React.createElement("h2", {
  className: classes.title
}, "Before approving your mockup, pay close attention"), /*#__PURE__*/React.createElement("div", {
  className: classes.text
}, "Please make sure you have confirmed the following:"), /*#__PURE__*/React.createElement("ul", {
  className: classes.rules
}, rules.map((rule, idx) => /*#__PURE__*/React.createElement("li", {
  key: idx
}, idx + 1, ". ", rule))), /*#__PURE__*/React.createElement("div", {
  className: classes.text
}, "As soon as you approve your mockup, we will be moving your item(s) to production. That means we will no longer be able to make any changes to your order. Please take this opportunity to confirm the quantity of item(s) and the sizes (where applicable) are also correct!"), /*#__PURE__*/React.createElement(Button, {
  dataButton: "Continue",
  type: "primary",
  onClick: onSkip,
  textTransform: ButtonTextTransform.none,
  disabled: !isMockupAvailable
}, /*#__PURE__*/React.createElement(_Tooltip, {
  disableHoverListener: isMockupAvailable,
  title: tooltipText
}, /*#__PURE__*/React.createElement("span", null, "Continue to Mockup Approval"))));
export default BeforeApprovingMockup;